import React from "react";
import SubNav from "./SubNav/SubNav";
import { Switch, Route, useRouteMatch, Redirect } from "react-router-dom";
import MangeFoods from "./MangeFoods/MangeFoods";
import "./Dashboard.css";
import DeleteFood from "./DeleteFood/DeleteFood";
import EditFoods from "./EditFoods/EditFoods";
import NewFood from "./NewFood/NewFood";
import MangeUsers from "./MangeUsers/MangeUser";
import Orders from "./Orders/Orders";

const Dashboard = ({ props, user }) => {
  let match = useRouteMatch();

  return (
    <div className="dashborad">
      <div className="dashborad__nav">
        <SubNav />
      </div>
      <div className="dashborad__content">
        <Switch>
          <Route
            path={`${match.path}/`}
            exact
            render={(props) => (
              <MangeFoods key={user.id} props={props} user={user} />
            )}
          />

          <Route
            path={`${match.path}/foods`}
            exact
            render={(props) => (
              <MangeFoods key={user.id} props={props} user={user} />
            )}
          />

          <Route
            path={`${match.path}/users`}
            render={(props) => (
              <MangeUsers key={user.id} props={props} user={user} />
            )}
          />
          <Route
            path={`${match.path}/orders`}
            render={(props) => (
              <Orders key={user.id} props={props} user={user} />
            )}
          />
          <Route
            path={`${match.path}/foods/edit/:id`}
            render={(props) => <EditFoods key={user.id} props={props} />}
          />
          <Route
            path={`${match.path}/foods/delete/:id`}
            render={(props) => <DeleteFood key={user.id} props={props} />}
          />
          <Route path={`/dashborad/foods/new`} component={NewFood} />
          <Redirect to="/dashborad" />
        </Switch>
      </div>
    </div>
  );
};

export default Dashboard;
